__turbopack_context__.v({
  "goal": "Goal-module-scss-module__XxQmEa__goal",
  "headline": "Goal-module-scss-module__XxQmEa__headline",
  "imageBlock": "Goal-module-scss-module__XxQmEa__imageBlock",
  "img": "Goal-module-scss-module__XxQmEa__img",
  "subHeadline": "Goal-module-scss-module__XxQmEa__subHeadline",
});
